import React from 'react'
import Team from './Team'

const Intro = () => {
  return (
    <section className='flex flex-col justify-center items-center'>
       <div className='w-full mb-20 flex flex-col md:flex-row'>
         <div className='md:w-1/2 lg:mx-[11%] lg:py-20 flex flex-col'>
          <h1 className='text-3xl lg:text-5xl font-bold 
          bg-gradient-to-r from-white via-enhancedTeal to-purpleCustom 
     inline-block text-transparent bg-clip-text
          '>Hello! We are OpenPolitica!</h1>
          <p className='md:text-xl mt-5 font-nunito text-white indent-4'>We are team of driven individuals from all around the world working on one mission: to empower  the future of policymaking through modern technology and user friendly design!</p>
         </div>
         <div className='block md:hidden mt-8 '>
          <h1 className='text-center text-xl font-bold text-white'>
            Our Team
          </h1>
         </div>
        <Team/>
       </div>
    </section>
  )
}

export default Intro